import jQuery from 'jquery';
import Swiper from "swiper";
import 'readmore-js';

const lightbox = require('lightbox2');

jQuery(function ($) {
    'use strict';

    const isMobile = window.matchMedia('(max-width: 1000px)');

    $('.object__information-content__desc').readmore({
        collapsedHeight: 300,
        moreLink: '<a href="#" class="readmore-toggle"><i class="fa fa-plus" aria-hidden="true"></i> Lees meer</a>',
        lessLink: '<a href="#" class="readmore-toggle"><i class="fa fa-minus" aria-hidden="true"></i> Toon minder</a>',
        beforeToggle: function (trigger, element, expanded) {
            element.attr('aria-expanded', !expanded);
        }
    });

    $('.object__information-content__specs').readmore({
        collapsedHeight: 400,
        moreLink: '<a href="#" class="readmore-toggle"><i class="fa fa-plus" aria-hidden="true"></i> Toon alle kenmerken</a>',
        lessLink: '<a href="#" class="readmore-toggle"><i class="fa fa-minus" aria-hidden="true"></i> Toon minder</a>',
        beforeToggle: function (trigger, element, expanded) {
            element.attr('aria-expanded', !expanded);
        }
    });

    if (Wonen.map) {
        var map = new SingleMap({data: Wonen.map, apiKey: Wonen.mapsApiKey});

        map.load();
    }

    initSlider(isMobile);
    window.addEventListener('resize', e => initSlider(isMobile));

    lightbox.option({
        'resizeDuration': 0,
        'wrapAround': true,
        'imageFadeDuration': 0,
        'albumLabel': "%1/%2",
        'disableScrolling': true
    });

    document.querySelector('.js-object__gallery__open').addEventListener('click', () => {
        lightbox.start($('[data-lightbox="woning-gallery"]'))
    })
});

const initSlider = (isMobile) => {
    if (isMobile.matches) {
        if (document.querySelector('.swiper-container').swiper) {
            return;
        }

        new Swiper('.swiper-container', {
            loop: true,
            slidesPerView: 1,
            autoHeight: false
        });
    } else {
        if (document.querySelector('.swiper-container').swiper) {
            document.querySelector('.swiper-container').swiper.destroy();
        }
    }
}
